import LoadingDialog from '@map/components/LoadingDialog';
import { useStoreIsReady } from '@map/hooks/storeState';
import { useCurrentUser, useFetchUser } from '@map/hooks/userApi';
import useMountEffect from '@shared/hooks/useMountEffect';
import PolyfillLoader from '@shared/lib/PolyfillLoader';
import setSentryUser from '@shared/lib/sentry/setSentryUser';
import axios from 'axios';
import { Suspense, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Root from './Root';

const UserReadyContainer = () => {
  const history = useHistory();

  // handles scroll to top on route change
  useMountEffect(() => {
    let prevPath = history.location.pathname;
    return history.listen((state, action) => {
      if (action === 'PUSH' && prevPath !== state.pathname) {
        document.body.scrollIntoView({ block: 'start', inline: 'start' });
      }
      prevPath = state.pathname;
    });
  });

  return (
    <Suspense fallback={<LoadingDialog />}>
      <Root />
    </Suspense>
  );
};

const StoreReadyContainer = () => {
  const user = useCurrentUser();
  const [userLoading, setUserLoading] = useState(!user.id);
  const fetchUser = useFetchUser();

  useMountEffect(() => {
    const signal = axios.CancelToken.source();
    fetchUser({ cancelToken: signal.token })
      .catch((ex) => {
        if (!axios.isCancel(ex)) {
          throw ex;
        }
      })
      .finally(() => setUserLoading(false));
    return () => signal.cancel();
  });

  useEffect(() => setSentryUser(user), [user]);

  return <PolyfillLoader>{userLoading ? null : <UserReadyContainer />}</PolyfillLoader>;
};

// wait to load remote data until the redux store had been loaded
const Container = () => (useStoreIsReady() ? <StoreReadyContainer /> : null);

export default Container;
